// source: messaging/live_control.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var messaging_common_pb = require('../messaging/common_pb.js');
goog.object.extend(proto, messaging_common_pb);
goog.exportSymbol('proto.com.alfredcamera.protobuf.FocusControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.FocusControl.FocusState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.FocusControl.FocusState.FocusMode', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LiveControls', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LogUploadRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.LogUploadRequest.LogType', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ManualRecordingControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ManualRecordingResultRequest', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ManualRecordingResultResponse', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.OrientationControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.OrientationControl.OrientationState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.PushToTalkControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ResolutionControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.SirenControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.SirenControl.SirenState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.TorchControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.TorchControl.TorchState', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.TorchControl.TorchState.TorchLevel', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ZoomControl', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.ZoomControl.ZoomState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.PushToTalkControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.PushToTalkControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.PushToTalkControl.displayName = 'proto.com.alfredcamera.protobuf.PushToTalkControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.displayName = 'proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ManualRecordingControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ManualRecordingControl.displayName = 'proto.com.alfredcamera.protobuf.ManualRecordingControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ManualRecordingResultRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.displayName = 'proto.com.alfredcamera.protobuf.ManualRecordingResultRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ManualRecordingResultResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.displayName = 'proto.com.alfredcamera.protobuf.ManualRecordingResultResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.TorchControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.TorchControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.TorchControl.displayName = 'proto.com.alfredcamera.protobuf.TorchControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.TorchControl.TorchState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.TorchControl.TorchState.displayName = 'proto.com.alfredcamera.protobuf.TorchControl.TorchState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.OrientationControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.OrientationControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.OrientationControl.displayName = 'proto.com.alfredcamera.protobuf.OrientationControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.OrientationControl.OrientationState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.displayName = 'proto.com.alfredcamera.protobuf.OrientationControl.OrientationState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.SirenControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.SirenControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.SirenControl.displayName = 'proto.com.alfredcamera.protobuf.SirenControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.SirenControl.SirenState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.SirenControl.SirenState.displayName = 'proto.com.alfredcamera.protobuf.SirenControl.SirenState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ResolutionControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ResolutionControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ResolutionControl.displayName = 'proto.com.alfredcamera.protobuf.ResolutionControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ZoomControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ZoomControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ZoomControl.displayName = 'proto.com.alfredcamera.protobuf.ZoomControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.ZoomControl.ZoomState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.displayName = 'proto.com.alfredcamera.protobuf.ZoomControl.ZoomState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.FocusControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.FocusControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.FocusControl.displayName = 'proto.com.alfredcamera.protobuf.FocusControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.FocusControl.FocusState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.FocusControl.FocusState.displayName = 'proto.com.alfredcamera.protobuf.FocusControl.FocusState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.LogUploadRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.LogUploadRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.LogUploadRequest.displayName = 'proto.com.alfredcamera.protobuf.LogUploadRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.PushToTalkControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.PushToTalkControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.PushToTalkControl}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.PushToTalkControl;
  return proto.com.alfredcamera.protobuf.PushToTalkControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.PushToTalkControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.PushToTalkControl}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.PushToTalkControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.PushToTalkControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.toObject = function(includeInstance, msg) {
  var f, obj = {
    active: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState;
  return proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActive();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool active = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState} returns this
 */
proto.com.alfredcamera.protobuf.PushToTalkControl.PushToTalkState.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ManualRecordingControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    recording: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingControl}
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ManualRecordingControl;
  return proto.com.alfredcamera.protobuf.ManualRecordingControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingControl}
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecording(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ManualRecordingControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecording();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool recording = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.prototype.getRecording = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingControl} returns this
 */
proto.com.alfredcamera.protobuf.ManualRecordingControl.prototype.setRecording = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingResultRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultRequest}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ManualRecordingResultRequest;
  return proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingResultRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultRequest}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingResultRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && messaging_common_pb.OperationResult.toObject(includeInstance, f),
    timestamp: jspb.Message.getFieldWithDefault(msg, 2, 0),
    eventId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    snapshotRange: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ManualRecordingResultResponse;
  return proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new messaging_common_pb.OperationResult;
      reader.readMessage(value,messaging_common_pb.OperationResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      messaging_common_pb.OperationResult.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSnapshotRange();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional OperationResult result = 1;
 * @return {?proto.com.alfredcamera.protobuf.OperationResult}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.getResult = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.OperationResult} */ (
    jspb.Message.getWrapperField(this, messaging_common_pb.OperationResult, 1));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.OperationResult|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} returns this
*/
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} returns this
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 timestamp = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} returns this
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string event_id = 3;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} returns this
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string snapshot_range = 4;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.getSnapshotRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.ManualRecordingResultResponse} returns this
 */
proto.com.alfredcamera.protobuf.ManualRecordingResultResponse.prototype.setSnapshotRange = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.TorchControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.TorchControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.TorchControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.TorchControl.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.TorchControl}
 */
proto.com.alfredcamera.protobuf.TorchControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.TorchControl;
  return proto.com.alfredcamera.protobuf.TorchControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.TorchControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.TorchControl}
 */
proto.com.alfredcamera.protobuf.TorchControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.TorchControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.TorchControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.TorchControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.TorchControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.TorchControl.TorchState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.TorchControl.TorchState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.TorchControl.TorchState}
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.TorchControl.TorchState;
  return proto.com.alfredcamera.protobuf.TorchControl.TorchState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.TorchControl.TorchState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.TorchControl.TorchState}
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.TorchControl.TorchState.TorchLevel} */ (reader.readEnum());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.TorchControl.TorchState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.TorchControl.TorchState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.TorchLevel = {
  DISABLED: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

/**
 * optional TorchLevel level = 1;
 * @return {!proto.com.alfredcamera.protobuf.TorchControl.TorchState.TorchLevel}
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.prototype.getLevel = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.TorchControl.TorchState.TorchLevel} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.TorchControl.TorchState.TorchLevel} value
 * @return {!proto.com.alfredcamera.protobuf.TorchControl.TorchState} returns this
 */
proto.com.alfredcamera.protobuf.TorchControl.TorchState.prototype.setLevel = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.OrientationControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.OrientationControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.OrientationControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.OrientationControl.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.OrientationControl}
 */
proto.com.alfredcamera.protobuf.OrientationControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.OrientationControl;
  return proto.com.alfredcamera.protobuf.OrientationControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.OrientationControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.OrientationControl}
 */
proto.com.alfredcamera.protobuf.OrientationControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.OrientationControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.OrientationControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.OrientationControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.OrientationControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.OrientationControl.OrientationState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.toObject = function(includeInstance, msg) {
  var f, obj = {
    degree: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.OrientationControl.OrientationState}
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.OrientationControl.OrientationState;
  return proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.OrientationControl.OrientationState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.OrientationControl.OrientationState}
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDegree(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.OrientationControl.OrientationState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDegree();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 degree = 1;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.prototype.getDegree = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.OrientationControl.OrientationState} returns this
 */
proto.com.alfredcamera.protobuf.OrientationControl.OrientationState.prototype.setDegree = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.SirenControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.SirenControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.SirenControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.SirenControl.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.SirenControl}
 */
proto.com.alfredcamera.protobuf.SirenControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.SirenControl;
  return proto.com.alfredcamera.protobuf.SirenControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.SirenControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.SirenControl}
 */
proto.com.alfredcamera.protobuf.SirenControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.SirenControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.SirenControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.SirenControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.SirenControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.SirenControl.SirenState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.SirenControl.SirenState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.SirenControl.SirenState}
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.SirenControl.SirenState;
  return proto.com.alfredcamera.protobuf.SirenControl.SirenState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.SirenControl.SirenState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.SirenControl.SirenState}
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.SirenControl.SirenState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.SirenControl.SirenState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.SirenControl.SirenState} returns this
 */
proto.com.alfredcamera.protobuf.SirenControl.SirenState.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ResolutionControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ResolutionControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ResolutionControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ResolutionControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ResolutionControl}
 */
proto.com.alfredcamera.protobuf.ResolutionControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ResolutionControl;
  return proto.com.alfredcamera.protobuf.ResolutionControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ResolutionControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ResolutionControl}
 */
proto.com.alfredcamera.protobuf.ResolutionControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState} */ (reader.readEnum());
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ResolutionControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ResolutionControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ResolutionControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ResolutionControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState = {
  AUTO: 0,
  PRESET_1: 1,
  PRESET_2: 2,
  PRESET_3: 3,
  PRESET_4: 4
};

/**
 * optional ResolutionState state = 1;
 * @return {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState}
 */
proto.com.alfredcamera.protobuf.ResolutionControl.prototype.getState = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.ResolutionControl.ResolutionState} value
 * @return {!proto.com.alfredcamera.protobuf.ResolutionControl} returns this
 */
proto.com.alfredcamera.protobuf.ResolutionControl.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ZoomControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ZoomControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ZoomControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: (f = msg.getState()) && proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.toObject(includeInstance, f),
    animate: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl}
 */
proto.com.alfredcamera.protobuf.ZoomControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ZoomControl;
  return proto.com.alfredcamera.protobuf.ZoomControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ZoomControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl}
 */
proto.com.alfredcamera.protobuf.ZoomControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.alfredcamera.protobuf.ZoomControl.ZoomState;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAnimate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ZoomControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ZoomControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ZoomControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.serializeBinaryToWriter
    );
  }
  f = message.getAnimate();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.toObject = function(includeInstance, msg) {
  var f, obj = {
    zoomIn: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    scale: jspb.Message.getFieldWithDefault(msg, 2, 0),
    coordX: jspb.Message.getFieldWithDefault(msg, 3, 0),
    coordY: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.ZoomControl.ZoomState;
  return proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setZoomIn(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScale(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCoordX(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCoordY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZoomIn();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getScale();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCoordX();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCoordY();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional bool zoom_in = 1;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.getZoomIn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} returns this
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.setZoomIn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 scale = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.getScale = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} returns this
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.setScale = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 coord_x = 3;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.getCoordX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} returns this
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.setCoordX = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 coord_y = 4;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.getCoordY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} returns this
 */
proto.com.alfredcamera.protobuf.ZoomControl.ZoomState.prototype.setCoordY = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional ZoomState state = 1;
 * @return {?proto.com.alfredcamera.protobuf.ZoomControl.ZoomState}
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.getState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.ZoomControl.ZoomState} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.ZoomControl.ZoomState, 1));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.ZoomControl.ZoomState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl} returns this
*/
proto.com.alfredcamera.protobuf.ZoomControl.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl} returns this
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.hasState = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool animate = 2;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.getAnimate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.ZoomControl} returns this
 */
proto.com.alfredcamera.protobuf.ZoomControl.prototype.setAnimate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.FocusControl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.FocusControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.FocusControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.FocusControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: (f = msg.getState()) && proto.com.alfredcamera.protobuf.FocusControl.FocusState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.FocusControl}
 */
proto.com.alfredcamera.protobuf.FocusControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.FocusControl;
  return proto.com.alfredcamera.protobuf.FocusControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.FocusControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.FocusControl}
 */
proto.com.alfredcamera.protobuf.FocusControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.alfredcamera.protobuf.FocusControl.FocusState;
      reader.readMessage(value,proto.com.alfredcamera.protobuf.FocusControl.FocusState.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.FocusControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.FocusControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.FocusControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.FocusControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.alfredcamera.protobuf.FocusControl.FocusState.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.FocusControl.FocusState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.FocusControl.FocusState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    coordX: jspb.Message.getFieldWithDefault(msg, 2, 0),
    coordY: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.FocusControl.FocusState}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.FocusControl.FocusState;
  return proto.com.alfredcamera.protobuf.FocusControl.FocusState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.FocusControl.FocusState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.FocusControl.FocusState}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.FocusControl.FocusState.FocusMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCoordX(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCoordY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.FocusControl.FocusState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.FocusControl.FocusState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCoordX();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCoordY();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.FocusMode = {
  AUTO: 0,
  MANUAL: 1
};

/**
 * optional FocusMode mode = 1;
 * @return {!proto.com.alfredcamera.protobuf.FocusControl.FocusState.FocusMode}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.getMode = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.FocusControl.FocusState.FocusMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.FocusControl.FocusState.FocusMode} value
 * @return {!proto.com.alfredcamera.protobuf.FocusControl.FocusState} returns this
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 coord_x = 2;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.getCoordX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.FocusControl.FocusState} returns this
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.setCoordX = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 coord_y = 3;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.getCoordY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.FocusControl.FocusState} returns this
 */
proto.com.alfredcamera.protobuf.FocusControl.FocusState.prototype.setCoordY = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional FocusState state = 1;
 * @return {?proto.com.alfredcamera.protobuf.FocusControl.FocusState}
 */
proto.com.alfredcamera.protobuf.FocusControl.prototype.getState = function() {
  return /** @type{?proto.com.alfredcamera.protobuf.FocusControl.FocusState} */ (
    jspb.Message.getWrapperField(this, proto.com.alfredcamera.protobuf.FocusControl.FocusState, 1));
};


/**
 * @param {?proto.com.alfredcamera.protobuf.FocusControl.FocusState|undefined} value
 * @return {!proto.com.alfredcamera.protobuf.FocusControl} returns this
*/
proto.com.alfredcamera.protobuf.FocusControl.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.alfredcamera.protobuf.FocusControl} returns this
 */
proto.com.alfredcamera.protobuf.FocusControl.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.FocusControl.prototype.hasState = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.LogUploadRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.LogUploadRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    uploadUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.LogUploadRequest}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.LogUploadRequest;
  return proto.com.alfredcamera.protobuf.LogUploadRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.LogUploadRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.LogUploadRequest}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.LogUploadRequest.LogType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.LogUploadRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.LogUploadRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUploadUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.LogType = {
  ANY: 0,
  LIVE: 1
};

/**
 * optional LogType type = 1;
 * @return {!proto.com.alfredcamera.protobuf.LogUploadRequest.LogType}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.prototype.getType = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.LogUploadRequest.LogType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.LogUploadRequest.LogType} value
 * @return {!proto.com.alfredcamera.protobuf.LogUploadRequest} returns this
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string upload_url = 2;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.prototype.getUploadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.LogUploadRequest} returns this
 */
proto.com.alfredcamera.protobuf.LogUploadRequest.prototype.setUploadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.LiveControls = {
  RESERVED_LIVE_CONTROL: 0,
  PUSH_TO_TALK: 1,
  RECORDING_CONTROL: 2,
  RECORDING_RESULT: 3,
  TORCH: 4,
  ORIENTATION: 5,
  SIREN: 6,
  RESOLUTION: 8,
  ZOOM: 9,
  FOCUS: 10,
  LOG_UPLOAD: 16
};

goog.object.extend(exports, proto.com.alfredcamera.protobuf);
